/**
 * 延迟操作
 * @param ms
 * @returns {Promise<any>}
 */
const timeout = (ms = 300) => {
    return new Promise(res => {
        window.setTimeout(() => {
            res();
        }, ms);
    });
};

const get_storage = key => {
    if ("localStorage" in window) {
        try {
            return window.localStorage.getItem(key);
        } catch (error) {
            return "";
        }
    }
};

const set_storage = (key, value) => {
    if ("localStorage" in window) {
        try {
            window.localStorage.setItem(key, value);
        } catch (error) {
            return "";
        }
    }
};

/**
 * 获取滚动条宽度
 * 思路:
 *  创建俩DIV为父子级关系, 父级添加溢出滚动属性, 此时父级的宽度 - 子集的宽度 就是scrollbar的宽度
 * @returns {number}
 */
const get_scrollbar_width = () => {
    let oDiv = document.createElement("div");
    oDiv.style.visibility = "hidden";
    oDiv.style.overflow = "scroll";
    oDiv.style.msOverflowStyle = "scrollbar";
    document.body.append(oDiv);

    let insideDiv = document.createElement("div");
    oDiv.appendChild(insideDiv);
    let scrollbarWidth = oDiv.offsetWidth - insideDiv.offsetWidth;
    oDiv.parentNode.removeChild(oDiv);
    return scrollbarWidth;
};

/**
 * 格式化时间
 * @returns {string}
 */
const format_time = times => {
    let h = String("00" + Math.floor(times / 3600)).slice(-2) + ":";
    let m = String("00" + Math.floor((times % 3600) / 60)).slice(-2) + ":";
    let s = String("00" + Math.floor((times % 3600) % 60)).slice(-2);
    return times > 3600 ? h + m + s : m + s;
};

/**
 * 保存数据
 * @param key
 * @param args
 * @param value
 *
 * @example
 *  set_schema_data('stageNavigation',data)
 *  set_schema_data('stage',{stageId:123},data)
 */
const set_schema_data = (key, args, value = null) => {
    if (value === null) {
        window.__schema[key] = args;
    } else {
        key += `?${$.param(args)}`;
        window.__schema[key] = value;
    }
};

/**
 * 获取数据
 * @param key
 * @param args
 * @returns {*}
 * @example
 *  get_schema_from_key('stageNavigation')
 *  get_schema_from_key('stage',{stageId:123})
 */
const get_schema_from_key = (key, args = null) => {
    if (args) {
        key += `?${$.param(args)}`;
    }
    return window.__schema[key];
};

/**
 * 配置 iScroll 插件
 * @param Function
 */
const iScroll = {
    plugin: null,
    iscrollFn: (ele, Fn, parallax) => {
        let option = {
            disablePointer: false,
            mouseWheel: true,
            scrollbars: false,
            scrollX: false,
            scrollY: true,
            click: true,
            probeType: 3,
            indicators: parallax
        };

        iScroll.plugin = new IScroll(ele, option);
        iScroll.plugin.on("scroll", Fn);
        iScroll.plugin.on("beforeScrollStart", () => iScroll.plugin.refresh());

        document.addEventListener("touchmove", iScroll._preventDefault, {
            passive: false
        });
    },

    destroy: () => {
        iScroll.plugin.destroy();
        document.removeEventListener("touchmove", iScroll._preventDefault, {
            passive: false
        });
    },
    _preventDefault: ev => {
        ev = ev || window.event;
        ev.preventDefault();
    }
};

// const download_single = fullDownloadPath => {
//     let iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     if ("onload" in iframe) {
//         iframe.onload = iframeLoad;
//     } else if (iframe.attachEvent) {
//         iframe.attachEvent("onload", iframeLoad);
//     } else {
//         iframe.onreadystatechange = function onreadystatechange() {
//             if (iframe.readyState === "complete") {
//                 iframeLoad;
//             }
//         };
//     }
//     iframe.src = "";
//     document.body.appendChild(iframe);
//     iframe.contentWindow.location.href = fullDownloadPath;
//     // iframe.parentNode.removeChild(iframe);
//     // setTimeout((iframe.contentWindow.location.href = fullDownloadPath), 50);
//     function iframeLoad() {
//         const win = iframe.contentWindow;
//         const doc = win.document;
//         if (win.location.href === fullDownloadPath) {
//             if (doc.body.childNodes.length > 0) {
//                 // response is error
//             }
//             iframe.parentNode.removeChild(iframe);
//         }
//     }
// };
const download_single = fullDownloadPath => {
    let random = Math.round(Math.random() * 10000);
    let a = document.createElement("a");
    a.id = `down-${random}`;
    a.href = fullDownloadPath;
    a.download = name;
    a.style.display = "none";
    document.body.appendChild(a);
    document.getElementById(`down-${random}`).click();
    setTimeout(() => {
        document.getElementById(`down-${random}`).remove();
    }, 1000);
};

const getDays = () => {
    //构造当前日期对象
    let date = new Date();
    let year = date.getFullYear(); //获取年份
    let mouth = date.getMonth() + 1; //获取当前月份
    let days; //定义当月的天数；
    if (mouth == 2) {
        //当月份为二月时，根据闰年还是非闰年判断天数
        days = year % 4 == 0 ? 29 : 28;
    } else if (
        mouth == 1 ||
        mouth == 3 ||
        mouth == 5 ||
        mouth == 7 ||
        mouth == 8 ||
        mouth == 10 ||
        mouth == 12
    ) {
        //月份为：1,3,5,7,8,10,12 时，为大月.则天数为31；
        days = 31;
    } else {
        //其他月份，天数为：30.
        days = 30;
    }
    days;
    return days;
};

export {
    timeout,
    set_storage,
    get_storage,
    get_scrollbar_width,
    format_time,
    get_schema_from_key,
    set_schema_data,
    download_single,
    iScroll,
    getDays
};
